import { IEvent } from "@quest/adapter-interface";
import { detectDeviceEnvironmentConstants, ingenuity, SpineBase } from "@quest/base-core";
import { BaseViewBehavior } from "@quest/murka-games-behavior-panther";

export class investigationRoomView extends BaseViewBehavior {
    protected resize(evt: IEvent): void {
        super.resize(evt);
        this.setElementPosition();
    }

    private setElementPosition():void{
            if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
            this.getContainerByID('criminalWire_E').angle = 20;
            this.getContainerByID('weaponWire_O').angle = -107.5;
            } else {
               this.getContainerByID('criminalWire_E').angle = 38; 
               this.getContainerByID('weaponWire_O').angle =  56.5;
            }
    }
    createCloneSpine(json:any):SpineBase{
        let spine = this.createSpine(json);
        return spine;
    }
}